export { DMS_MODULE } from '../../constants';
export const NAME = 'SubSegmentCategory';
export const CRUMB_LABEL_KEY = 'SegmentSubCategory';
export const CRUMB_LABEL_EDIT = 'edtSubSegmentSubCategory';
export const CRUMB_LABEL_LIST = 'grdSubSegmentSubCategory';
